// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Card externo: cabeçalho, rodapé e área de conteúdo */

.styles_pageShell__ju92z {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  margin: 0 2rem 24px;
  overflow: hidden;
}

.styles_header__oHIcy {
  padding: 20px 24px 16px;
}

.styles_headerTop__NgkdS {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
}

.styles_titleRow__HRCat {
  align-items: center;
  color: #1b3a5f;
  display: flex;
  font-family: inherit;
  font-size: 26px;
  font-weight: 600;
  gap: 12px;
  letter-spacing: -0.3px;
}

.styles_contentArea__BDGxF {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 16px;
}

/* Cards internos: filtros e tabela */

.styles_innerCard__cyPup {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.styles_filtersCard__RTmeH {
  padding: 20px 24px;
}

.styles_filtersGrid__tEfOE {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr;
  width: 100%;
}

@media (min-width: 600px) {
  .styles_filtersGrid__tEfOE {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 900px) {
  .styles_filtersGrid__tEfOE {
    grid-template-columns: repeat(4, minmax(145px, 1fr)) auto;
  }
}

.styles_tableSection__BUfYy {
  position: relative;
  overflow-x: auto;
  background-color: #ffffff;
}

.styles_tableOverlay__vSQj\\+ {
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.styles_table__-F1Nd {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.styles_table__-F1Nd thead {
  background-color: #fafafa;
}

.styles_table__-F1Nd th {
  border-bottom: 1px solid #e0e0e0;
  box-sizing: border-box;
  /* color/font-size iguais ao que .accordion_table th REALMENTE renderiza nas abas — não a
     regra "só cabeçalho" (#9e9e9e/0.6875rem) sozinha: em
     components/TableCard/TableView/styles.module.css existe uma segunda regra logo abaixo
     (".accordion_table th, .accordion_table td") pensada pra célula de dado, que sem querer
     também pega o th e, por vir depois no arquivo, vence nessas duas propriedades. O
     resultado visual final nas abas é este mix (maiúsculo+negrito+letter-spacing da 1ª regra,
     cor/tamanho da 2ª) — reproduzido aqui de propósito, não é o comportamento "limpo" que a
     1ª regra sozinha sugere. Não mexemos no arquivo compartilhado pra não arriscar as abas
     já validadas. */
  color: #424242;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 10px 16px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}

.styles_table__-F1Nd th:hover {
  background-color: #f0f0f0;
}

.styles_table__-F1Nd td {
  border-bottom: 1px solid #f0f0f0;
  box-sizing: border-box;
  color: #424242;
  font-size: 0.875rem;
  height: 56px;
  overflow: hidden;
  padding: 8px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_table__-F1Nd tbody tr:hover {
  background-color: #fafafa;
}

.styles_colEmpresa__RbK99 {
  width: 22%;
}

.styles_colCnpj__BOFZE {
  width: 14%;
}

.styles_colTipo__L1ksm {
  width: 14%;
}

.styles_colPeriodo__IsAD2 {
  width: 8rem;
}

/* TXM-325 item 11 — Competência e Situação não truncam (sem reticências no intervalo/chip) */
.styles_table__-F1Nd td.styles_colPeriodo__IsAD2,
.styles_table__-F1Nd td.styles_colStatus__cUndA {
  overflow: visible;
  text-overflow: clip;
}

.styles_colStatus__cUndA {
  width: 12%;
}

.styles_colAcoes__IzEfU {
  position: sticky;
  right: 0;
  width: 9rem;
  min-width: 9rem;
  background-color: #ffffff;
  box-shadow: -8px 0 12px rgba(255, 255, 255, 0.92);
  z-index: 1;
}

.styles_table__-F1Nd thead .styles_colAcoes__IzEfU {
  background-color: #fafafa;
  z-index: 2;
}

.styles_table__-F1Nd tbody tr:hover .styles_colAcoes__IzEfU {
  background-color: #fafafa;
}

.styles_acoesCell__X2lDk {
  display: flex;
  gap: 2px;
  align-items: center;
}

.styles_emptyRow__LMQ\\+P td {
  color: #18316e;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  padding: 2.5rem 1rem;
  text-align: center;
  white-space: normal;
}

.styles_paginationWrap__16h\\+G {
  padding: 0;
}

.styles_loadingWrap__Ul3bR {
  min-height: 280px;
  position: relative;
}

@media (max-width: 780px) {
  .styles_pageShell__ju92z {
    margin: 0 1rem 16px;
  }

  .styles_contentArea__BDGxF {
    padding: 0 16px 12px;
  }

  .styles_header__oHIcy {
    padding: 16px 16px 12px;
  }

  .styles_headerTop__NgkdS {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Apuracoes/components/ApuracoesListagem/styles.module.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA,qCAAqC;;AAErC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB;;;;;;;;oBAQkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,6FAA6F;AAC7F;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":["/* Card externo: cabeçalho, rodapé e área de conteúdo */\n\n.pageShell {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n  display: flex;\n  flex-direction: column;\n  margin: 0 2rem 24px;\n  overflow: hidden;\n}\n\n.header {\n  padding: 20px 24px 16px;\n}\n\n.headerTop {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.titleRow {\n  align-items: center;\n  color: #1b3a5f;\n  display: flex;\n  font-family: inherit;\n  font-size: 26px;\n  font-weight: 600;\n  gap: 12px;\n  letter-spacing: -0.3px;\n}\n\n.contentArea {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 24px 16px;\n}\n\n/* Cards internos: filtros e tabela */\n\n.innerCard {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.filtersCard {\n  padding: 20px 24px;\n}\n\n.filtersGrid {\n  align-items: center;\n  display: grid;\n  gap: 8px;\n  grid-template-columns: 1fr;\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  .filtersGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 900px) {\n  .filtersGrid {\n    grid-template-columns: repeat(4, minmax(145px, 1fr)) auto;\n  }\n}\n\n.tableSection {\n  position: relative;\n  overflow-x: auto;\n  background-color: #ffffff;\n}\n\n.tableOverlay {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n}\n\n.table {\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.table thead {\n  background-color: #fafafa;\n}\n\n.table th {\n  border-bottom: 1px solid #e0e0e0;\n  box-sizing: border-box;\n  /* color/font-size iguais ao que .accordion_table th REALMENTE renderiza nas abas — não a\n     regra \"só cabeçalho\" (#9e9e9e/0.6875rem) sozinha: em\n     components/TableCard/TableView/styles.module.css existe uma segunda regra logo abaixo\n     (\".accordion_table th, .accordion_table td\") pensada pra célula de dado, que sem querer\n     também pega o th e, por vir depois no arquivo, vence nessas duas propriedades. O\n     resultado visual final nas abas é este mix (maiúsculo+negrito+letter-spacing da 1ª regra,\n     cor/tamanho da 2ª) — reproduzido aqui de propósito, não é o comportamento \"limpo\" que a\n     1ª regra sozinha sugere. Não mexemos no arquivo compartilhado pra não arriscar as abas\n     já validadas. */\n  color: #424242;\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  padding: 10px 16px;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n\n.table th:hover {\n  background-color: #f0f0f0;\n}\n\n.table td {\n  border-bottom: 1px solid #f0f0f0;\n  box-sizing: border-box;\n  color: #424242;\n  font-size: 0.875rem;\n  height: 56px;\n  overflow: hidden;\n  padding: 8px 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table tbody tr:hover {\n  background-color: #fafafa;\n}\n\n.colEmpresa {\n  width: 22%;\n}\n\n.colCnpj {\n  width: 14%;\n}\n\n.colTipo {\n  width: 14%;\n}\n\n.colPeriodo {\n  width: 8rem;\n}\n\n/* TXM-325 item 11 — Competência e Situação não truncam (sem reticências no intervalo/chip) */\n.table td.colPeriodo,\n.table td.colStatus {\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.colStatus {\n  width: 12%;\n}\n\n.colAcoes {\n  position: sticky;\n  right: 0;\n  width: 9rem;\n  min-width: 9rem;\n  background-color: #ffffff;\n  box-shadow: -8px 0 12px rgba(255, 255, 255, 0.92);\n  z-index: 1;\n}\n\n.table thead .colAcoes {\n  background-color: #fafafa;\n  z-index: 2;\n}\n\n.table tbody tr:hover .colAcoes {\n  background-color: #fafafa;\n}\n\n.acoesCell {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n}\n\n.emptyRow td {\n  color: #18316e;\n  font-size: 1rem;\n  font-weight: 500;\n  height: auto;\n  padding: 2.5rem 1rem;\n  text-align: center;\n  white-space: normal;\n}\n\n.paginationWrap {\n  padding: 0;\n}\n\n.loadingWrap {\n  min-height: 280px;\n  position: relative;\n}\n\n@media (max-width: 780px) {\n  .pageShell {\n    margin: 0 1rem 16px;\n  }\n\n  .contentArea {\n    padding: 0 16px 12px;\n  }\n\n  .header {\n    padding: 16px 16px 12px;\n  }\n\n  .headerTop {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageShell": `styles_pageShell__ju92z`,
	"header": `styles_header__oHIcy`,
	"headerTop": `styles_headerTop__NgkdS`,
	"titleRow": `styles_titleRow__HRCat`,
	"contentArea": `styles_contentArea__BDGxF`,
	"innerCard": `styles_innerCard__cyPup`,
	"filtersCard": `styles_filtersCard__RTmeH`,
	"filtersGrid": `styles_filtersGrid__tEfOE`,
	"tableSection": `styles_tableSection__BUfYy`,
	"tableOverlay": `styles_tableOverlay__vSQj+`,
	"table": `styles_table__-F1Nd`,
	"colEmpresa": `styles_colEmpresa__RbK99`,
	"colCnpj": `styles_colCnpj__BOFZE`,
	"colTipo": `styles_colTipo__L1ksm`,
	"colPeriodo": `styles_colPeriodo__IsAD2`,
	"colStatus": `styles_colStatus__cUndA`,
	"colAcoes": `styles_colAcoes__IzEfU`,
	"acoesCell": `styles_acoesCell__X2lDk`,
	"emptyRow": `styles_emptyRow__LMQ+P`,
	"paginationWrap": `styles_paginationWrap__16h+G`,
	"loadingWrap": `styles_loadingWrap__Ul3bR`
};
export default ___CSS_LOADER_EXPORT___;
